import { normalizeTerminalPlanStatus } from "src/lib/normalizeTerminalPlanStatus";
import { PersistentChatWithMessages } from "~shared/types/persistent-chat-types";

const THUMB_EXCLUDED_ASSISTANT = (m: { id: string; metadata?: any; content?: string | null; role: string }) => {
  if (m.role !== "assistant") return true;
  if (m.id === "error" || m.id === "tbd") return true;
  if (m.metadata?.questionAsked) return true;
  if (m.metadata?.helpMenuGreeting) return true;
  if (m.metadata?.source === "help_menu_agentic") return true;
  return false;
};

/**
 * When the user should return to the tab (plan ready, follow-up, question, CTA, or completed plan on the last
 * message), the agentic chat has “pending attention” for a purple check favicon. Thumbs/optional feedback alone
 * does not trigger the indicator.
 */
export function getAgenticChatNeedsUserAttention(
  state: {
    streaming: boolean;
    pendingAgentResponse: boolean;
    activePlan: { status: string } | null;
    suggestedAction: unknown | null;
    currentUserQuestion: { questions: unknown[] } | null;
    ctaAction: { status: string } | null;
  },
  messages: PersistentChatWithMessages["messages"] | undefined,
  _feedbackByMessageId: Record<string, number> | undefined,
): boolean {
  if (state.streaming || state.pendingAgentResponse) return false;

  const cta = state.ctaAction;
  if (cta && cta.status === "awaiting_input") return true;

  if (state.suggestedAction) return true;

  if (state.currentUserQuestion?.questions?.length) return true;

  const plan = state.activePlan;
  if (plan) {
    if (plan.status === "proposed" || plan.status === "paused" || plan.status === "cancelling") {
      return true;
    }
  }

  for (let i = (messages?.length ?? 0) - 1; i >= 0; i--) {
    const m = messages![i];
    if (m.role !== "assistant" || !m.id) continue;
    if (THUMB_EXCLUDED_ASSISTANT(m as any)) continue;

    const raw = m.metadata?.plan as { status: string; steps: { status: string }[] } | undefined;
    if (raw) {
      const inline = normalizeTerminalPlanStatus(raw);
      if (inline.status === "completed" || inline.status === "cancelled") {
        return true;
      }
    }
    break;
  }

  return false;
}
